import { initializeApp } from 'firebase/app';
import { getAnalytics, logEvent } from 'firebase/analytics';
import {FirebaseAnalyticsEvent} from "@/lib/firebase/types.ts";

const firebaseConfig = {
	apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
	authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
	projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
	storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
	messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
	appId: import.meta.env.VITE_FIREBASE_APP_ID,
	measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID,
};

const FirebaseApp = initializeApp(firebaseConfig);

const firebaseAnalytics = getAnalytics(FirebaseApp);

const firebaseLogEvent = (
	eventName: FirebaseAnalyticsEvent,
	payload: Record<string, unknown> = {}
) => {
	logEvent(firebaseAnalytics, eventName, {
		source_type: import.meta.env.VITE_FIREBASE_SOURCE_TYPE,
		...payload,
	});
}
export { firebaseLogEvent };
export default FirebaseApp;
